function normalizeText(value) {
  return String(value || "")
    .toLowerCase()
    .replace(/[^a-z]/g, "");
}

export function isClinicalJustificationRequired(program) {
  return Boolean(program && program.requireClinicalJustification);
}

export function isMensOrWomensHealthProgram(program) {
  const normalizedProgramName = normalizeText(program && program.name);
  return normalizedProgramName.includes("menshealth") || normalizedProgramName.includes("womenshealth") || normalizedProgramName.includes("womenhealth");
}

export function hasClinicalJustificationRxItem(rxItems) {
  return (rxItems || []).some((item) => {
    return String((item && item.productGroup) || "")
      .toLowerCase()
      .includes("clinical justification");
  });
}

export function hasTestosteroneMedication(prescription, program) {
  const selectedMedicationIds = new Set((prescription && prescription.medications ? prescription.medications : []).filter(Boolean));
  return ((program && program.allowedMedications) || []).some((medication) => {
    const medicationId = medication.businessItemCategoryId || medication.id;
    if (!selectedMedicationIds.has(medicationId)) return false;

    const fields = [medication.label, medication.name];
    return fields.some((field) =>
      String(field || "")
        .toLowerCase()
        .includes("testosterone cypionate"),
    );
  });
}

export function getClinicalJustificationValidationError(prescriptions, programs) {
  for (const prescription of prescriptions || []) {
    if (!prescription || !prescription.businessProgramId) continue;

    const program = (programs || []).find((item) => item.businessProgramId === prescription.businessProgramId);
    const requireByProgramSetting = isClinicalJustificationRequired(program);
    const requireByTestosterone = isMensOrWomensHealthProgram(program) && hasTestosteroneMedication(prescription, program);
    if (!requireByProgramSetting && !requireByTestosterone) continue;

    if (!hasClinicalJustificationRxItem(prescription.rxItems)) {
      const programName = program && program.name ? program.name : "the selected program";
      let reason = `Clinical justification is required because ${programName} has "Require Clinical Justification" option enabled.`;

      if (requireByTestosterone && !requireByProgramSetting) {
        reason = `Clinical justification is required because ${programName} includes a Testosterone injectable.`;
      } else if (requireByProgramSetting && requireByTestosterone) {
        reason = `Clinical justification is required because ${programName} has "Require Clinical Justification" enabled and includes a Testosterone injectable.`;
      }

      return {
        message: `Clinical justification is required . Please select at least one Rx Item from the Clinical Justification product group.`,
        error: new Error(reason),
      };
    }
  }

  return null;
}
